import { render, staticRenderFns } from "./signup-page.vue?vue&type=template&id=c8767ffa&scoped=true&"
import script from "./signup-page.vue?vue&type=script&lang=js&"
export * from "./signup-page.vue?vue&type=script&lang=js&"
import style0 from "./signup-page.vue?vue&type=style&index=0&id=c8767ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8767ffa",
  null
  
)

export default component.exports